import React, { useState, useContext } from "react";
import "./Landing.css";
import { useMsal } from "@azure/msal-react";
import Logo from "../../assets/images/phoenix_icon.png";
import { Typography } from "@mui/material";
import { TestService } from "../../services/TestService";
import { AlertContext } from "../Dashboard/Dashboard";

export default function Landing() {
  const { instance } = useMsal();
  const [formInput, setFormInput] = useState("");
  const [responseDisplay, setResponseDisplay] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { warning } = useContext(AlertContext);

  const testApi = () => {
    setResponseDisplay("Loading");
    setIsLoading(true);
    const id = formInput;
    TestService.TestApi(instance, id).then(res => {
      if (res.name) {
        setResponseDisplay(`Success getting: ${res.name}`);
      } else {
        setResponseDisplay(`Carrier ${id} not found`);
      }
      setIsLoading(false);
    }).catch(error => {
      console.error(error);
      warning(error);
    });
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  const handleFormInput = (event) => {
    setFormInput(event.target.value);
  };

  const clearForm = () => {
    setFormInput("");
    setResponseDisplay("");
  };

  return (
    <>
      <div className="Landing-title">
        <Typography variant="title" color="black_solid.80">
          Great things are taking flight...
        </Typography>
      </div>
      <div className="Landing-logo">
        <img src={Logo} alt="Phoenix Placeholder" title="Phoenix Placeholder" />
      </div>
      <div>
        <input style={{marginLeft: "20px"}} type="text" value={formInput} onChange={handleFormInput}></input>
        <button style={{marginLeft: "20px"}} onClick={testApi} disabled={isLoading}>Get Carrier</button>
        <button style={{marginLeft: "20px"}} onClick={clearForm}>Clear</button>
        <button style={{marginLeft: "20px"}} onClick={handleLogout}>Logout</button>
        <span style={{marginLeft: "20px", fontWeight: 800}}>{responseDisplay}</span>
      </div>
    </>
  );
}